function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg132459145186395(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M471.541,277.614c0,0,3.107-120.915-68.136-177.65c-62.889-50.081-151.048-59.204-211.981,0.572 c-21.711,21.299-34.098,57.809-61.059,72.855c-30.23,16.871-70.855,27.746-92.568,82.514 c-21.713,54.769-0.589,117.09,44.729,144.735c45.318,27.645,109.508-16.951,171.819-29.643 C316.657,358.305,462.19,427.726,471.541,277.614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M471.541,277.614c0,0,3.107-120.915-68.136-177.65 c-62.889-50.081-151.048-59.204-211.981,0.572c-21.711,21.299-34.098,57.809-61.059,72.855 c-30.23,16.871-70.855,27.746-92.568,82.514c-21.713,54.769-0.589,117.09,44.729,144.735 c45.318,27.645,109.508-16.951,171.819-29.643C316.657,358.305,462.19,427.726,471.541,277.614z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clouds"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    d: "M384.43,68.921c0,0,0-26.392-30.409-26.966 c-25.884-0.488-26.966,20.081-29.835,29.835c-2.869,9.754-7.459,0-18.36,2.295c-10.901,2.295-10.901,13.196-12.622,20.081 c-1.721,6.885-9.18-1.147-17.212,1.147c-8.032,2.295-12.049,10.901-13.77,14.344c-1.721,3.442-13.56-1.762-20.533,0.778 S227.224,124,227.224,124h203.679c0,0,8.032-18.934-5.737-31.556c-13.77-12.622-22.95-4.59-31.556-8.606 C385.004,79.822,384.43,68.921,384.43,68.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    d: "M108.204,169.318c0,0,0-16.113-18.565-16.464 c-15.803-0.298-16.464,12.26-18.215,18.215c-1.752,5.955-4.554,0-11.209,1.401s-6.656,8.057-7.706,12.26 c-1.051,4.204-5.605-0.701-10.509,0.701s-7.356,6.656-8.407,8.757c-1.051,2.102-8.279-1.076-12.536,0.475 c-4.257,1.551-8.832,8.282-8.832,8.282h124.354c0,0,4.904-11.56-3.503-19.266c-8.407-7.706-14.012-2.802-19.266-5.254 C108.555,175.973,108.204,169.318,108.204,169.318z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Buildings"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 84.356,
    y: 298.094,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 10.003,
    height: 8.827
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.542,
    y: 303.437,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 4.055,
    height: 3.484
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    points: "484.515,353.84 446.599,353.84 446.599,283.784  449.13,283.784 449.13,276.531 360.292,276.531 360.292,283.784 363.37,283.784 363.37,387.972 340.066,387.972 340.066,164.444  260.166,164.444 260.166,333.487 230.954,333.487 230.954,314.772 238.605,314.772 238.605,306.861 174.717,306.861  174.717,193.455 178.852,193.455 178.852,187.521 101.307,187.521 101.307,193.455 106.867,193.455 106.867,307.054  45.582,307.054 45.582,388.297 13.4,388.297  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.608,
    y: 162,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 86.641,
    height: 2.427
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 113.806,
    y: 200.048,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 200.048,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.433,
    y: 200.048,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.747,
    y: 200.048,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.806,
    y: 214.554,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 214.554,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.433,
    y: 214.554,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.747,
    y: 214.554,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.806,
    y: 229.059,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 229.059,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.433,
    y: 229.059,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.747,
    y: 229.059,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.806,
    y: 243.564,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 243.564,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.433,
    y: 243.564,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.747,
    y: 243.564,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.806,
    y: 258.07,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 258.07,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.433,
    y: 258.07,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.747,
    y: 258.07,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.806,
    y: 272.575,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 272.575,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.433,
    y: 272.575,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.747,
    y: 272.575,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.806,
    y: 287.08,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 287.08,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.433,
    y: 287.08,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.747,
    y: 287.08,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.806,
    y: 301.586,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 301.586,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.433,
    y: 301.586,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.747,
    y: 301.586,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 113.806,
    y: 314.854,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 314.854,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.433,
    y: 314.854,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.747,
    y: 314.854,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.806,
    y: 329.359,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 329.359,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.433,
    y: 329.359,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.747,
    y: 329.359,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.806,
    y: 343.865,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 343.865,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.433,
    y: 343.865,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.747,
    y: 343.865,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.806,
    y: 358.37,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 358.37,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.433,
    y: 358.37,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.747,
    y: 358.37,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.806,
    y: 372.875,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 372.875,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.433,
    y: 372.875,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.747,
    y: 372.875,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.806,
    y: 387.381,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 387.381,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.433,
    y: 387.381,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.747,
    y: 387.381,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.806,
    y: 401.886,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 401.886,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.433,
    y: 401.886,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.747,
    y: 401.886,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.806,
    y: 416.391,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.12,
    y: 416.391,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.433,
    y: 416.391,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.747,
    y: 416.391,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 169.712,
    y: 314.854,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.026,
    y: 314.854,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.339,
    y: 314.854,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.653,
    y: 314.854,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.712,
    y: 329.359,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.026,
    y: 329.359,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.339,
    y: 329.359,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.653,
    y: 329.359,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.712,
    y: 343.865,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.026,
    y: 343.865,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.339,
    y: 343.865,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.653,
    y: 343.865,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.712,
    y: 358.37,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.026,
    y: 358.37,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.339,
    y: 358.37,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.653,
    y: 358.37,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.712,
    y: 372.875,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.026,
    y: 372.875,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.339,
    y: 372.875,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.653,
    y: 372.875,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.712,
    y: 387.381,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.026,
    y: 387.381,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.339,
    y: 387.381,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.653,
    y: 387.381,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.712,
    y: 401.886,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.026,
    y: 401.886,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.339,
    y: 401.886,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.653,
    y: 401.886,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.712,
    y: 416.391,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.026,
    y: 416.391,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.339,
    y: 416.391,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.653,
    y: 416.391,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 57.112,
    y: 314.854,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.426,
    y: 314.854,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.74,
    y: 314.854,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.054,
    y: 314.854,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.112,
    y: 329.359,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.426,
    y: 329.359,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.74,
    y: 329.359,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.054,
    y: 329.359,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.112,
    y: 343.865,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.426,
    y: 343.865,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.74,
    y: 343.865,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.054,
    y: 343.865,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.112,
    y: 358.37,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.426,
    y: 358.37,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.74,
    y: 358.37,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.054,
    y: 358.37,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.112,
    y: 372.875,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.426,
    y: 372.875,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.74,
    y: 372.875,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.054,
    y: 372.875,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.112,
    y: 387.381,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.426,
    y: 387.381,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.74,
    y: 387.381,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.054,
    y: 387.381,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.112,
    y: 401.886,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.426,
    y: 401.886,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.74,
    y: 401.886,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.054,
    y: 401.886,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.112,
    y: 416.391,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.426,
    y: 416.391,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.74,
    y: 416.391,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.054,
    y: 416.391,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 376.855,
    y: 286.421,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.169,
    y: 286.421,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.483,
    y: 286.421,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.796,
    y: 286.421,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.855,
    y: 300.927,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.169,
    y: 300.927,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.483,
    y: 300.927,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.796,
    y: 300.927,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.855,
    y: 315.432,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.169,
    y: 315.432,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.483,
    y: 315.432,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.796,
    y: 315.432,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.855,
    y: 329.937,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.169,
    y: 329.937,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.483,
    y: 329.937,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.796,
    y: 329.937,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.855,
    y: 344.443,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.169,
    y: 344.443,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.483,
    y: 344.443,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.796,
    y: 344.443,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.855,
    y: 358.948,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.169,
    y: 358.948,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.483,
    y: 358.948,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.796,
    y: 358.948,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.855,
    y: 373.453,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.169,
    y: 373.453,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.483,
    y: 373.453,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.796,
    y: 373.453,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.855,
    y: 387.959,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.169,
    y: 387.959,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.483,
    y: 387.959,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.796,
    y: 387.959,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    width: 9.759,
    height: 9.149
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 267.69,
    y1: 169.719,
    x2: 267.69,
    y2: 434.771
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 277.37,
    y1: 169.719,
    x2: 277.37,
    y2: 434.771
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 287.049,
    y1: 169.719,
    x2: 287.049,
    y2: 434.771
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 296.729,
    y1: 169.719,
    x2: 296.729,
    y2: 434.771
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 306.409,
    y1: 169.719,
    x2: 306.409,
    y2: 434.771
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 316.088,
    y1: 169.719,
    x2: 316.088,
    y2: 434.771
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 325.768,
    y1: 169.719,
    x2: 325.768,
    y2: 434.771
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    x1: 335.448,
    y1: 169.719,
    x2: 335.448,
    y2: 434.771
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M19.176,385.105c3.332,0.793,7.543,0.196,8.835-0.021c-0.009,1.791,0.038,3.676,0.214,5.635 c0.242,2.729,0.636,5.587,1.423,8.479c0.009,0.033,0.023,0.066,0.031,0.098c-0.493-0.774-1.944-2.893-2.073-3.044 c-1.831-2.116-6.612-5.128-9.496-3.904c-2.078,0.882-2.687,3.37-1.643,5.268c1.066,1.938,3.616,2.897,5.684,3.198 c2.332,0.34,7.241-1.083,7.631-1.198c0.775,2.748,1.793,5.504,2.977,8.237c0.675,1.563,1.403,3.117,2.154,4.665 c-0.448-0.656-0.853-1.239-0.918-1.314c-1.831-2.116-6.612-5.128-9.496-3.904c-2.078,0.882-2.686,3.37-1.643,5.268 c1.065,1.939,3.616,2.897,5.684,3.199c2.098,0.306,6.307-0.824,7.417-1.138c0.294,0.591,0.581,1.185,0.877,1.774 c1.422,2.83,2.852,5.648,4.17,8.455c0.465,0.989,0.887,1.98,1.313,2.97c-0.398-0.582-0.739-1.069-0.798-1.138 c-1.831-2.116-6.612-5.128-9.496-3.904c-2.078,0.882-2.686,3.37-1.643,5.268c1.066,1.938,3.616,2.897,5.684,3.198 c2.002,0.292,5.897-0.716,7.217-1.082c0.405,1.027,0.813,2.055,1.159,3.068c0.221,0.697,0.482,1.354,0.665,2.066 c0.196,0.702,0.39,1.397,0.582,2.085c0.321,1.339,0.661,2.718,0.941,4.032c0.202,0.912,0.378,1.785,0.557,2.664 c-0.451-0.99-1.376-2.909-1.472-3.061c-1.489-2.369-5.758-6.071-8.795-5.297c-2.187,0.558-3.166,2.924-2.422,4.958 c0.76,2.077,3.136,3.411,5.134,4.023c2.2,0.673,7.072,0.058,7.68-0.023c0.292,1.456,0.562,2.874,0.795,4.217 c0.18,1.021,0.342,1.998,0.493,2.942h1.954c-0.189-1.046-0.395-2.142-0.622-3.283c-0.291-1.48-0.63-3.055-0.995-4.668 c0.366-0.145,2.444-0.986,4.285-2.015c1.604,1.737,5.713,3.769,6.245,4.028c-0.56,1.375-1.117,2.707-1.663,3.956 c-0.297,0.684-0.588,1.34-0.877,1.982h2.065c0.173-0.414,0.346-0.83,0.522-1.26c0.574-1.394,1.159-2.895,1.746-4.443 c0.59,0.123,5.412,1.103,7.66,0.595c2.038-0.46,4.507-1.614,5.419-3.629c0.894-1.973,0.094-4.406-2.046-5.125 c-2.97-0.998-7.504,2.376-9.165,4.627c-0.098,0.133-1,1.692-1.554,2.686c0.236-0.633,0.473-1.246,0.708-1.901 c0.474-1.292,0.909-2.596,1.382-3.996c0.205-0.684,0.411-1.376,0.62-2.074c0.222-0.688,0.369-1.443,0.558-2.17 c0.404-1.696,0.73-3.434,1.021-5.193c1.133,0.412,5.175,1.818,7.27,1.672c2.084-0.146,4.7-0.913,5.906-2.766 c1.182-1.815,0.76-4.341-1.246-5.376c-2.785-1.436-7.777,1.211-9.761,3.185c-0.124,0.123-1.387,1.699-2.065,2.578 c0.167-1.058,0.338-2.114,0.471-3.19c0.386-3.107,0.679-6.264,0.986-9.411c0.093-0.965,0.198-1.924,0.299-2.885 c0.401,0.151,5.171,1.927,7.516,1.762c2.085-0.146,4.7-0.912,5.907-2.766c1.182-1.815,0.76-4.341-1.246-5.376 c-2.785-1.436-7.777,1.211-9.76,3.185c-0.15,0.149-1.965,2.419-2.398,3.019c0.223-2.117,0.466-4.224,0.789-6.291 c0.442-2.854,1.034-5.629,1.806-8.275c0.187,0.071,5.156,1.946,7.558,1.778c2.085-0.146,4.7-0.912,5.907-2.766 c1.182-1.815,0.76-4.341-1.246-5.376c-2.785-1.436-7.777,1.211-9.76,3.185c-0.13,0.13-1.515,1.857-2.154,2.695 c-0.088-0.045-0.072-0.037-0.159-0.082c0.861-2.825,2.051-5.452,3.286-7.857c0.713-1.394,1.472-2.687,2.239-3.929 c0.89,0.444,4.978,2.429,7.157,2.516c2.088,0.083,4.771-0.391,6.175-2.1c1.374-1.674,1.232-4.232-0.648-5.48 c-2.61-1.734-7.863,0.35-10.051,2.094c-0.082,0.065-0.632,0.608-1.225,1.205c0.004-0.131,0.008-0.282,0.011-0.455 c0.087-0.135,0.175-0.275,0.261-0.405c1.311-1.974,2.632-3.701,3.815-5.221c0.68-0.859,1.311-1.622,1.91-2.33 c1.101-0.019,5.534-0.154,7.473-1.064c1.891-0.888,4.054-2.546,4.512-4.71c0.448-2.119-0.856-4.323-3.101-4.565 c-3.115-0.335-6.817,3.934-7.956,6.49c-0.098,0.221-1.24,3.852-1.182,3.852c0,0,0.054-0.001,0.066-0.001 c-0.59,0.67-1.214,1.394-1.88,2.199c-1.212,1.489-2.567,3.182-3.918,5.121c-0.025-3.014-0.558-9.272-4.535-9.651 c-5.25-0.5-6.75,5.5-3.5,8.75c2.28,2.28,5.292,2.59,6.89,2.573c-1.007,1.503-2.019,3.118-2.963,4.869 c-1.303,2.41-2.551,5.01-3.49,7.857c-0.011,0.032-0.018,0.067-0.028,0.099c0.016-0.918-0.025-3.486-0.05-3.682 c-0.359-2.775-2.685-7.925-5.767-8.495c-2.22-0.41-4.1,1.329-4.277,3.488c-0.18,2.204,1.418,4.411,2.977,5.803 c1.758,1.57,6.637,3.091,7.026,3.21c-0.87,2.719-1.541,5.58-2.061,8.512c-0.299,1.676-0.549,3.374-0.777,5.079 c-0.012-0.794-0.028-1.504-0.041-1.603c-0.36-2.775-2.686-7.925-5.767-8.494c-2.22-0.41-4.1,1.329-4.277,3.487 c-0.181,2.205,1.418,4.411,2.976,5.803c1.582,1.412,5.715,2.793,6.814,3.143c-0.081,0.655-0.169,1.308-0.247,1.964 c-0.376,3.144-0.737,6.284-1.186,9.353c-0.158,1.082-0.353,2.141-0.544,3.201c-0.011-0.705-0.026-1.299-0.038-1.389 c-0.36-2.775-2.685-7.925-5.767-8.494c-2.22-0.41-4.1,1.329-4.277,3.488c-0.181,2.204,1.418,4.411,2.977,5.803 c1.509,1.348,5.313,2.656,6.617,3.079c-0.229,1.08-0.456,2.162-0.726,3.199c-0.201,0.703-0.345,1.395-0.585,2.09 c-0.224,0.693-0.445,1.38-0.665,2.06c-0.471,1.294-0.949,2.632-1.439,3.882c-0.335,0.872-0.67,1.697-1.005,2.53 c0.17-1.075,0.457-3.185,0.461-3.365c0.043-1.859-0.617-4.88-1.931-7.004c0.008-0.274-0.008-0.548-0.051-0.82 c-0.344-2.138-2.353-3.727-4.534-3.146c-3.028,0.806-4.948,6.121-5.092,8.915c-0.009,0.165,0.1,1.963,0.186,3.097 c-0.152-0.659-0.293-1.3-0.458-1.976c-0.318-1.339-0.674-2.666-1.052-4.096c-0.207-0.684-0.416-1.374-0.627-2.072 c-0.194-0.696-0.488-1.407-0.731-2.118c-0.599-1.637-1.285-3.268-2.014-4.895c1.172-0.281,5.32-1.338,6.985-2.616 c1.658-1.272,3.417-3.354,3.401-5.565c-0.016-2.166-1.76-4.04-4.005-3.796c-3.115,0.338-5.819,5.301-6.384,8.041 c-0.035,0.171-0.22,2.183-0.3,3.29c-0.445-0.975-0.885-1.95-1.367-2.921c-1.392-2.804-2.889-5.599-4.369-8.393 c-0.454-0.856-0.896-1.714-1.342-2.571c0.418-0.095,5.375-1.246,7.241-2.677c1.658-1.272,3.417-3.354,3.401-5.565 c-0.016-2.166-1.761-4.04-4.005-3.796c-3.115,0.339-5.818,5.301-6.384,8.041c-0.042,0.207-0.304,3.102-0.334,3.841 c-0.981-1.889-1.941-3.78-2.812-5.683c-1.205-2.624-2.243-5.265-3.059-7.898c0.195-0.044,5.374-1.221,7.284-2.687 c1.658-1.272,3.417-3.353,3.401-5.565c-0.015-2.166-1.761-4.04-4.005-3.796c-3.115,0.338-5.818,5.301-6.384,8.041 c-0.037,0.18-0.239,2.387-0.31,3.438c-0.098,0.01-0.08,0.008-0.178,0.019c-0.84-2.832-1.297-5.68-1.594-8.368 c-0.175-1.556-0.255-3.053-0.3-4.512c0.987-0.12,5.492-0.72,7.357-1.849c1.788-1.082,3.764-2.958,3.992-5.158 c0.222-2.154-1.306-4.209-3.564-4.213c-3.133-0.006-6.365,4.63-7.228,7.291c-0.047,0.145-0.361,1.669-0.574,2.782 c-0.01-0.658-0.033-1.338-0.03-1.969c0.004-2.369,0.154-4.539,0.302-6.459c0.093-1.091,0.199-2.076,0.308-2.997 c0.907-0.624,4.531-3.182,5.646-5.01c1.088-1.784,1.977-4.36,1.165-6.417c-0.796-2.014-3.099-3.134-5.105-2.097 c-2.783,1.439-3.516,7.042-3.055,9.802c0.04,0.238,1.091,3.897,1.139,3.865c0,0,0.044-0.03,0.055-0.038 c-0.122,0.884-0.243,1.833-0.355,2.872c-0.191,1.921-0.388,4.093-0.444,6.472c-0.011,0.436-0.017,0.887-0.024,1.337 c-1.194-1.84-4.962-7.002-9.032-5.906C14.054,379.794,15.192,384.156,19.176,385.105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M89.839,409.238c2.127,0.507,4.815,0.125,5.64-0.014c-0.006,1.143,0.024,2.346,0.137,3.597 c0.155,1.742,0.406,3.567,0.908,5.413c0.006,0.021,0.014,0.042,0.02,0.063c-0.315-0.494-1.241-1.847-1.324-1.943 c-1.169-1.351-4.221-3.274-6.062-2.492c-1.327,0.563-1.715,2.151-1.049,3.363c0.68,1.238,2.309,1.849,3.629,2.042 c1.489,0.217,4.622-0.692,4.872-0.765c0.494,1.754,1.145,3.514,1.9,5.259c0.431,0.998,0.896,1.99,1.375,2.978 c-0.286-0.419-0.544-0.791-0.586-0.839c-1.169-1.351-4.221-3.274-6.062-2.492c-1.327,0.563-1.715,2.151-1.049,3.363 c0.68,1.238,2.309,1.85,3.629,2.042c1.34,0.195,4.027-0.526,4.735-0.726c0.188,0.377,0.371,0.756,0.56,1.133 c0.908,1.807,1.821,3.606,2.662,5.398c0.297,0.632,0.566,1.264,0.838,1.896c-0.254-0.372-0.472-0.683-0.51-0.727 c-1.169-1.351-4.221-3.274-6.062-2.492c-1.326,0.563-1.715,2.151-1.049,3.363c0.68,1.237,2.309,1.849,3.629,2.042 c1.278,0.186,3.765-0.457,4.607-0.691c0.258,0.655,0.519,1.312,0.74,1.959c0.141,0.445,0.308,0.864,0.424,1.319 c0.125,0.448,0.249,0.892,0.371,1.331c0.205,0.855,0.422,1.735,0.601,2.574c0.129,0.582,0.241,1.14,0.356,1.701 c-0.288-0.632-0.879-1.857-0.939-1.954c-0.951-1.512-3.676-3.876-5.615-3.382c-1.396,0.356-2.021,1.867-1.546,3.165 c0.485,1.326,2.002,2.178,3.278,2.568c1.405,0.429,4.515,0.037,4.903-0.015c0.186,0.929,0.359,1.835,0.508,2.692 c0.115,0.652,0.218,1.276,0.315,1.878h1.247c-0.121-0.668-0.252-1.367-0.397-2.096c-0.185-0.945-0.402-1.95-0.635-2.98 c0.234-0.093,1.56-0.629,2.735-1.286c1.024,1.109,3.647,2.406,3.987,2.571c-0.357,0.878-0.713,1.728-1.062,2.525 c-0.19,0.436-0.376,0.855-0.56,1.266h1.318c0.111-0.265,0.221-0.53,0.333-0.804c0.366-0.89,0.74-1.848,1.114-2.836 c0.376,0.079,3.455,0.704,4.89,0.38c1.301-0.294,2.877-1.03,3.46-2.317c0.571-1.26,0.06-2.813-1.306-3.272 c-1.896-0.637-4.791,1.516-5.851,2.954c-0.063,0.085-0.639,1.08-0.992,1.715c0.151-0.404,0.302-0.795,0.452-1.213 c0.303-0.825,0.58-1.657,0.882-2.551c0.131-0.437,0.263-0.878,0.396-1.324c0.142-0.439,0.236-0.921,0.356-1.385 c0.258-1.083,0.466-2.192,0.652-3.315c0.723,0.263,3.304,1.161,4.641,1.067c1.331-0.093,3-0.583,3.771-1.766 c0.755-1.159,0.485-2.771-0.795-3.432c-1.778-0.917-4.965,0.773-6.231,2.033c-0.079,0.079-0.886,1.085-1.318,1.646 c0.106-0.676,0.216-1.35,0.301-2.037c0.246-1.983,0.434-3.999,0.63-6.008c0.06-0.616,0.127-1.228,0.191-1.842 c0.256,0.097,3.301,1.23,4.798,1.125c1.331-0.093,3-0.582,3.771-1.766c0.754-1.159,0.485-2.771-0.796-3.432 c-1.778-0.917-4.965,0.773-6.231,2.033c-0.095,0.095-1.254,1.544-1.531,1.928c0.143-1.351,0.298-2.697,0.504-4.016 c0.282-1.822,0.66-3.594,1.153-5.283c0.119,0.045,3.292,1.242,4.825,1.135c1.331-0.093,3-0.582,3.771-1.766 c0.755-1.159,0.485-2.771-0.796-3.432c-1.778-0.917-4.965,0.773-6.231,2.033c-0.083,0.083-0.967,1.186-1.375,1.721 c-0.056-0.029-0.046-0.024-0.102-0.053c0.55-1.803,1.31-3.481,2.098-5.016c0.455-0.89,0.94-1.715,1.429-2.508 c0.568,0.284,3.178,1.551,4.569,1.606c1.333,0.053,3.046-0.249,3.942-1.341c0.877-1.069,0.787-2.701-0.414-3.499 c-1.666-1.107-5.02,0.224-6.417,1.337c-0.052,0.042-0.404,0.389-0.782,0.769c0.003-0.083,0.005-0.18,0.007-0.29 c0.056-0.086,0.112-0.175,0.167-0.258c0.837-1.26,1.681-2.363,2.436-3.333c0.434-0.548,0.837-1.035,1.219-1.487 c0.703-0.012,3.533-0.098,4.771-0.679c1.207-0.567,2.588-1.625,2.88-3.007c0.286-1.353-0.547-2.76-1.979-2.914 c-1.989-0.214-4.352,2.512-5.079,4.143c-0.063,0.141-0.791,2.459-0.755,2.459c0,0,0.034-0.001,0.042-0.001 c-0.376,0.427-0.775,0.89-1.2,1.404c-0.774,0.95-1.639,2.031-2.501,3.27c-0.016-1.924-0.356-5.919-2.896-6.161 c-3.352-0.319-4.309,3.511-2.234,5.586c1.455,1.456,3.378,1.654,4.399,1.643c-0.643,0.959-1.289,1.99-1.892,3.108 c-0.832,1.538-1.629,3.199-2.228,5.016c-0.007,0.021-0.011,0.043-0.018,0.063c0.01-0.586-0.016-2.225-0.032-2.351 c-0.23-1.771-1.715-5.059-3.682-5.423c-1.417-0.262-2.617,0.848-2.73,2.227c-0.115,1.407,0.905,2.816,1.9,3.705 c1.122,1.002,4.237,1.973,4.485,2.049c-0.555,1.736-0.984,3.562-1.316,5.434c-0.191,1.07-0.35,2.154-0.496,3.242 c-0.007-0.507-0.018-0.96-0.026-1.023c-0.23-1.771-1.715-5.059-3.681-5.423c-1.417-0.262-2.617,0.848-2.73,2.226 c-0.115,1.408,0.905,2.816,1.9,3.705c1.01,0.902,3.649,1.783,4.35,2.007c-0.051,0.418-0.108,0.835-0.158,1.254 c-0.24,2.007-0.47,4.012-0.757,5.971c-0.1,0.69-0.225,1.367-0.347,2.044c-0.007-0.45-0.017-0.829-0.024-0.887 c-0.23-1.772-1.714-5.059-3.682-5.423c-1.417-0.262-2.617,0.848-2.73,2.227c-0.115,1.407,0.905,2.816,1.9,3.705 c0.963,0.861,3.392,1.696,4.224,1.966c-0.146,0.689-0.291,1.38-0.463,2.042c-0.128,0.449-0.22,0.89-0.374,1.334 c-0.143,0.443-0.284,0.881-0.424,1.315c-0.301,0.826-0.605,1.68-0.919,2.479c-0.214,0.557-0.428,1.084-0.642,1.615 c0.108-0.686,0.292-2.034,0.294-2.148c0.027-1.187-0.394-3.116-1.233-4.472c0.005-0.175-0.005-0.35-0.033-0.523 c-0.219-1.365-1.502-2.379-2.895-2.008c-1.933,0.515-3.159,3.908-3.251,5.692c-0.005,0.105,0.064,1.253,0.119,1.977 c-0.097-0.421-0.187-0.83-0.293-1.261c-0.203-0.855-0.43-1.702-0.671-2.615c-0.132-0.436-0.266-0.877-0.4-1.323 c-0.124-0.444-0.312-0.898-0.467-1.352c-0.382-1.045-0.821-2.086-1.285-3.125c0.748-0.179,3.396-0.854,4.459-1.67 c1.058-0.812,2.181-2.141,2.171-3.553c-0.01-1.383-1.124-2.579-2.557-2.424c-1.989,0.216-3.715,3.384-4.075,5.133 c-0.022,0.109-0.14,1.393-0.191,2.1c-0.284-0.622-0.565-1.245-0.873-1.865c-0.889-1.79-1.844-3.574-2.789-5.358 c-0.29-0.547-0.572-1.094-0.857-1.642c0.267-0.061,3.432-0.795,4.622-1.709c1.059-0.812,2.181-2.141,2.171-3.553 c-0.01-1.383-1.124-2.579-2.557-2.424c-1.989,0.216-3.715,3.384-4.076,5.133c-0.027,0.132-0.194,1.98-0.213,2.452 c-0.626-1.206-1.239-2.413-1.795-3.628c-0.77-1.675-1.432-3.361-1.953-5.042c0.124-0.028,3.431-0.779,4.65-1.715 c1.059-0.812,2.181-2.141,2.171-3.553c-0.01-1.383-1.124-2.579-2.557-2.424c-1.989,0.216-3.714,3.384-4.075,5.133 c-0.024,0.115-0.153,1.524-0.198,2.195c-0.062,0.007-0.051,0.005-0.113,0.012c-0.536-1.808-0.828-3.626-1.017-5.342 c-0.112-0.993-0.163-1.949-0.191-2.88c0.63-0.077,3.506-0.46,4.697-1.181c1.141-0.691,2.403-1.888,2.548-3.293 c0.142-1.375-0.834-2.687-2.275-2.69c-2-0.004-4.063,2.956-4.615,4.655c-0.03,0.092-0.23,1.065-0.367,1.776 c-0.006-0.42-0.021-0.854-0.019-1.257c0.003-1.513,0.098-2.898,0.193-4.124c0.06-0.697,0.127-1.325,0.197-1.913 c0.579-0.398,2.893-2.031,3.604-3.198c0.694-1.139,1.262-2.783,0.744-4.097c-0.508-1.286-1.979-2-3.259-1.339 c-1.777,0.919-2.244,4.496-1.951,6.258c0.026,0.152,0.697,2.488,0.727,2.467c0,0,0.028-0.019,0.035-0.024 c-0.078,0.564-0.155,1.17-0.227,1.833c-0.122,1.226-0.248,2.613-0.284,4.132c-0.007,0.279-0.011,0.566-0.015,0.853 c-0.762-1.175-3.168-4.47-5.766-3.771C86.57,405.848,87.296,408.633,89.839,409.238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M76.858,385.476c-0.078,0.079-0.157,0.159-0.23,0.235c0.049-0.076,0.097-0.154,0.146-0.23 C76.801,385.479,76.831,385.478,76.858,385.476z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M243.394,414.573H107.67c-11.046,0-20-8.954-20-20V92.613 c0-11.046,8.954-20,20-20h135.725c11.046,0,20,8.954,20,20v301.96C263.394,405.619,254.44,414.573,243.394,414.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M263.394,104.101V93.7c0-11.646-9.441-21.087-21.087-21.087 H108.757c-11.646,0-21.087,9.441-21.087,21.087v10.401H263.394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M88.596,399.67c2.643,8.628,10.668,14.903,20.161,14.903 h133.551c9.493,0,17.518-6.275,20.161-14.903H88.596z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 226.404,
    y: 84.662,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.8211,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 16.67,
    height: 9.141
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.404,
    y: 84.662,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 0.7251,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 13,
    height: 9.141
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.038,
    y: 87.219,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 0.7251,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 2.348,
    height: 4.026
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 103.216,
    y: 87.498,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 0.8831,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 3.056,
    height: 5.239
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.018,
    y: 85.658,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 0.8831,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 3.056,
    height: 7.079
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.821,
    y: 83.484,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 0.8831,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 3.056,
    height: 9.253
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.6935,
      strokeMiterlimit: 10
    },
    d: "M246.457,69.801h-144.27 c-9.691,0-17.546,7.856-17.546,17.547v315.16c0,9.691,7.856,17.546,17.546,17.546h144.27c9.691,0,17.546-7.856,17.546-17.546 V87.348C264.003,77.657,256.147,69.801,246.457,69.801z M256.205,394.137c0,9.691-7.856,17.546-17.546,17.546H109.984 c-9.691,0-17.546-7.856-17.546-17.546V95.718c0-9.691,7.856-17.546,17.546-17.546h23.939l1.491,6.919 c0.897,4.16,4.575,7.131,8.831,7.131h64.052c4.256,0,7.934-2.97,8.831-7.131l1.491-6.919h20.039 c9.691,0,17.546,7.856,17.546,17.546V394.137z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M229.405,383.855H118.144c-4.602,0-8.333-3.731-8.333-8.333 v-242c0-4.602,3.731-8.333,8.333-8.333h111.261c4.602,0,8.333,3.731,8.333,8.333v242 C237.739,380.124,234.008,383.855,229.405,383.855z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M157.075,140.418c2.096,0,3.174,1.254,3.174,3.449v0.431h-2.038v-0.568 c0-0.98-0.392-1.352-1.077-1.352c-0.686,0-1.078,0.372-1.078,1.352c0,2.822,4.213,3.351,4.213,7.27 c0,2.194-1.098,3.448-3.214,3.448c-2.116,0-3.214-1.254-3.214-3.448v-0.843h2.038v0.98c0,0.98,0.431,1.332,1.117,1.332 c0.686,0,1.117-0.353,1.117-1.332c0-2.822-4.213-3.351-4.213-7.27C153.9,141.673,154.978,140.418,157.075,140.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M161.505,140.575h2.155v13.717h-2.155V140.575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M168.463,146.65h3.017V151c0,2.194-1.097,3.448-3.214,3.448c-2.116,0-3.214-1.254-3.214-3.448 v-7.133c0-2.195,1.097-3.449,3.214-3.449c2.116,0,3.214,1.254,3.214,3.449v1.332h-2.038v-1.47c0-0.98-0.431-1.352-1.117-1.352 c-0.686,0-1.117,0.372-1.117,1.352v7.407c0,0.98,0.431,1.332,1.117,1.332c0.686,0,1.117-0.353,1.117-1.332v-2.528h-0.98V146.65z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M174.795,144.357v9.935h-1.94v-13.717h2.704l2.214,8.21v-8.21h1.92v13.717h-2.214 L174.795,144.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M184.282,140.575h2.156v13.717h-2.156V140.575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M189.927,144.357v9.935h-1.94v-13.717h2.704l2.214,8.21v-8.21h1.92v13.717h-2.214 L189.927,144.357z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M121.109,192.814v1.034h-2.526v3.677h3.102v1.049h-4.253v-10.338h4.253v1.049h-3.102v3.53 H121.109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M126.555,198.559h-1.108l-1.713-8.226v8.241h-1.004v-10.338h1.61l1.698,8.256l1.639-8.256h1.61 v10.338h-1.093v-8.315L126.555,198.559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M131.632,196.492l-0.399,2.082h-1.063l1.979-10.338h1.669l1.979,10.338h-1.152l-0.399-2.082 H131.632z M131.779,195.502h2.304l-1.167-5.967L131.779,195.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M137.845,188.236v10.338h-1.152v-10.338H137.845z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M139.026,198.574v-10.338h1.152v9.289h2.954v1.049H139.026z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M147.454,196.492l-0.399,2.082h-1.063l1.979-10.338h1.669l1.979,10.338h-1.152l-0.398-2.082 H147.454z M147.602,195.502h2.304l-1.167-5.967L147.602,195.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M154.939,188.236c1.61,0,2.349,0.975,2.349,2.569v5.214c0,1.58-0.739,2.555-2.349,2.555h-2.422 v-10.338H154.939z M154.924,197.526c0.827,0,1.226-0.517,1.226-1.462v-5.317c0-0.945-0.399-1.462-1.241-1.462h-1.241v8.241 H154.924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M160.784,188.236c1.61,0,2.349,0.975,2.349,2.569v5.214c0,1.58-0.739,2.555-2.349,2.555h-2.422 v-10.338H160.784z M160.77,197.526c0.827,0,1.226-0.517,1.226-1.462v-5.317c0-0.945-0.399-1.462-1.241-1.462h-1.241v8.241 H160.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M166.511,188.236c1.624,0,2.304,0.827,2.304,2.363v0.842c0,1.137-0.399,1.846-1.285,2.127 c0.945,0.281,1.3,1.049,1.3,2.156v1.61c0,0.458,0.014,0.886,0.206,1.241h-1.166c-0.133-0.296-0.192-0.561-0.192-1.255v-1.625 c0-1.167-0.546-1.536-1.506-1.536h-0.812v4.416h-1.152v-10.338H166.511z M166.216,193.11c0.916,0,1.462-0.296,1.462-1.418v-0.99 c0-0.931-0.34-1.418-1.196-1.418h-1.122v3.825H166.216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M173.701,192.814v1.034h-2.526v3.677h3.101v1.049h-4.253v-10.338h4.253v1.049h-3.101v3.53 H173.701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M179.812,190.717v0.281h-1.093v-0.339c0-0.931-0.355-1.477-1.182-1.477 c-0.827,0-1.182,0.546-1.182,1.462c0,2.319,3.47,2.54,3.47,5.449c0,1.566-0.753,2.585-2.333,2.585 c-1.58,0-2.319-1.019-2.319-2.585v-0.59h1.078v0.65c0,0.931,0.384,1.477,1.211,1.477c0.827,0,1.211-0.546,1.211-1.477 c0-2.304-3.456-2.525-3.456-5.435c0-1.595,0.738-2.584,2.289-2.584C179.073,188.133,179.812,189.152,179.812,190.717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M185.303,190.717v0.281h-1.093v-0.339c0-0.931-0.355-1.477-1.182-1.477 c-0.827,0-1.182,0.546-1.182,1.462c0,2.319,3.47,2.54,3.47,5.449c0,1.566-0.753,2.585-2.333,2.585 c-1.581,0-2.319-1.019-2.319-2.585v-0.59h1.078v0.65c0,0.931,0.384,1.477,1.211,1.477c0.827,0,1.211-0.546,1.211-1.477 c0-2.304-3.456-2.525-3.456-5.435c0-1.595,0.738-2.584,2.289-2.584C184.564,188.133,185.303,189.152,185.303,190.717z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M119.691,239.899c1.624,0,2.319,0.96,2.319,2.525v1.241c0,1.639-0.768,2.496-2.407,2.496h-1.019 v4.076h-1.152v-10.338H119.691z M119.602,245.127c0.856,0,1.27-0.398,1.27-1.388v-1.374c0-0.945-0.34-1.418-1.182-1.418h-1.108 v4.179H119.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M123.882,248.155l-0.399,2.082h-1.063l1.979-10.338h1.669l1.979,10.338h-1.152l-0.399-2.082 H123.882z M124.03,247.165h2.304l-1.167-5.967L124.03,247.165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M133.419,242.38v0.281h-1.093v-0.339c0-0.931-0.355-1.477-1.181-1.477 c-0.827,0-1.182,0.546-1.182,1.462c0,2.319,3.47,2.54,3.47,5.449c0,1.566-0.753,2.585-2.333,2.585 c-1.58,0-2.319-1.019-2.319-2.585v-0.59h1.078v0.65c0,0.931,0.384,1.477,1.211,1.477c0.827,0,1.211-0.546,1.211-1.477 c0-2.304-3.456-2.525-3.456-5.435c0-1.595,0.738-2.584,2.289-2.584C132.681,239.796,133.419,240.815,133.419,242.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M138.91,242.38v0.281h-1.093v-0.339c0-0.931-0.355-1.477-1.181-1.477 c-0.827,0-1.182,0.546-1.182,1.462c0,2.319,3.47,2.54,3.47,5.449c0,1.566-0.753,2.585-2.333,2.585 c-1.581,0-2.319-1.019-2.319-2.585v-0.59h1.078v0.65c0,0.931,0.384,1.477,1.211,1.477c0.827,0,1.211-0.546,1.211-1.477 c0-2.304-3.456-2.525-3.456-5.435c0-1.595,0.738-2.584,2.289-2.584C138.172,239.796,138.91,240.815,138.91,242.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M142.673,250.237h-1.58l-1.418-10.338h1.122l1.211,8.802l1.152-8.787h1.137l1.137,8.802 l1.167-8.817h1.004l-1.403,10.338h-1.521l-0.989-7.016L142.673,250.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M148.443,242.395c0-1.58,0.783-2.599,2.363-2.599c1.595,0,2.378,1.019,2.378,2.599v5.346 c0,1.566-0.783,2.599-2.378,2.599c-1.58,0-2.363-1.034-2.363-2.599V242.395z M149.58,247.801c0,0.945,0.399,1.492,1.226,1.492 c0.842,0,1.226-0.546,1.226-1.492v-5.465c0-0.93-0.384-1.491-1.226-1.491c-0.827,0-1.226,0.561-1.226,1.491V247.801z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M156.577,239.899c1.624,0,2.304,0.827,2.304,2.363v0.842c0,1.137-0.399,1.846-1.285,2.127 c0.945,0.281,1.3,1.049,1.3,2.156v1.61c0,0.458,0.014,0.886,0.206,1.241h-1.167c-0.133-0.296-0.192-0.561-0.192-1.255v-1.625 c0-1.167-0.546-1.536-1.506-1.536h-0.812v4.416h-1.152v-10.338H156.577z M156.282,244.773c0.916,0,1.462-0.296,1.462-1.418 v-0.99c0-0.931-0.34-1.418-1.196-1.418h-1.122v3.825H156.282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M162.511,239.899c1.61,0,2.349,0.975,2.349,2.569v5.214c0,1.581-0.739,2.555-2.349,2.555h-2.422 v-10.338H162.511z M162.497,249.189c0.827,0,1.226-0.517,1.226-1.462v-5.316c0-0.945-0.399-1.462-1.241-1.462h-1.241v8.241 H162.497z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M137.307,290.156c1.624,0,2.304,0.827,2.304,2.363v0.842c0,1.137-0.399,1.846-1.285,2.126 c0.945,0.281,1.3,1.049,1.3,2.156v1.61c0,0.458,0.014,0.887,0.206,1.241h-1.166c-0.133-0.296-0.192-0.561-0.192-1.255v-1.625 c0-1.167-0.546-1.536-1.506-1.536h-0.812v4.416h-1.152v-10.339H137.307z M137.012,295.031c0.916,0,1.462-0.296,1.462-1.418 v-0.99c0-0.931-0.34-1.418-1.196-1.418h-1.122v3.825H137.012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M144.497,294.735v1.034h-2.526v3.677h3.101v1.049h-4.254v-10.339h4.254v1.049h-3.101v3.53 H144.497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M149.943,300.479h-1.108l-1.713-8.226v8.241h-1.004v-10.339h1.61l1.698,8.256l1.639-8.256h1.61 v10.339h-1.093v-8.315L149.943,300.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M157.531,294.735v1.034h-2.526v3.677h3.102v1.049h-4.253v-10.339h4.253v1.049h-3.102v3.53 H157.531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M162.977,300.479h-1.108l-1.713-8.226v8.241h-1.004v-10.339h1.61l1.698,8.256l1.639-8.256h1.61 v10.339h-1.093v-8.315L162.977,300.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M169.204,290.156c1.61,0,2.245,0.768,2.245,2.289v0.488c0,1.092-0.31,1.772-1.211,2.053 c1.004,0.28,1.388,1.078,1.388,2.215v0.871c0,1.551-0.753,2.423-2.363,2.423h-2.378v-10.339H169.204z M168.924,294.543 c0.916,0,1.389-0.296,1.389-1.374v-0.605c0-0.915-0.31-1.358-1.137-1.358h-1.137v3.337H168.924z M169.264,299.446 c0.842,0,1.226-0.443,1.226-1.402v-0.916c0-1.151-0.458-1.535-1.447-1.535h-1.004v3.854H169.264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M176.35,294.735v1.034h-2.526v3.677h3.102v1.049h-4.253v-10.339h4.253v1.049h-3.102v3.53H176.35z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M180.29,290.156c1.624,0,2.304,0.827,2.304,2.363v0.842c0,1.137-0.399,1.846-1.285,2.126 c0.945,0.281,1.3,1.049,1.3,2.156v1.61c0,0.458,0.014,0.887,0.206,1.241h-1.167c-0.133-0.296-0.192-0.561-0.192-1.255v-1.625 c0-1.167-0.546-1.536-1.506-1.536h-0.812v4.416h-1.152v-10.339H180.29z M179.995,295.031c0.916,0,1.462-0.296,1.462-1.418v-0.99 c0-0.931-0.34-1.418-1.196-1.418h-1.122v3.825H179.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M187.612,300.479h-1.108l-1.713-8.226v8.241h-1.004v-10.339h1.61l1.698,8.256l1.639-8.256h1.61 v10.339h-1.093v-8.315L187.612,300.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M195.199,294.735v1.034h-2.526v3.677h3.101v1.049h-4.253v-10.339h4.253v1.049h-3.101v3.53 H195.199z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M225.97,348.007h-101.58c-1.841,0-3.333-1.492-3.333-3.333 v-15.826c0-1.841,1.492-3.333,3.333-3.333h101.58c1.841,0,3.333,1.492,3.333,3.333v15.826 C229.304,346.515,227.811,348.007,225.97,348.007z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 157.5979 341.9668)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'BebasNeueRegular'",
      fontSize: "14.7609px"
    }
  }, "submit"), /*#__PURE__*/React.createElement("rect", {
    x: 117.543,
    y: 203.913,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 111.058,
    height: 16.869
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.543,
    y: 256.279,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 111.058,
    height: 16.87
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.949,
    y: 289.667,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 9.84,
    height: 9.841
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M333.195,427.925c0,0-6.019,1.158-13.89-0.232 c-7.871-1.389-16.205-8.102-16.205-8.102l-6.713,0.463v-29.169c0,0,11.575-2.083,15.279-1.852 c3.704,0.232,21.529,17.825,21.529,17.825V427.925z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "302.962,431.012 281.479,431.012 277.868,388.416  306.573,388.416  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.193,
    y: 381.258,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 26.735,
    height: 2.352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.942,
    y: 383.169,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 30.557,
    height: 8.334
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M320.694,421.211c-10.649-1.158-11.806-12.732-11.806-12.732 s-8.102,5.556-11.575,5.556c-3.473,0-4.398-2.547-5.093-4.321c-0.695-1.775,15.51-12.346,15.51-12.346s3.009-3.009,5.556-3.009 c2.547,0,13.427,14.816,15.51,17.362"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "454.869,452.007 454.027,356.873 449.785,381.478  451.464,452.007  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M448.171,452.007l0.547-51.739 c0,0,8.086-16.482,8.703-24.198c0.617-7.717,4.939-26.545,0.926-35.188c-4.013-8.643-0.486-37.897-0.486-37.897l-3.747-13.34 c-2.469-6.482-26.236-21.606-35.188-24.693c-8.951-3.087-19.446-3.704-27.471-2.778c-8.025,0.926-12.346,5.556-13.273,7.099 c-0.926,1.543-5.865,16.359-11.729,24.384c-5.865,8.025-10.803,13.89-15.124,20.063c-4.321,6.173-7.099,18.828-9.877,26.236 c-2.778,7.408-7.408,40.435-9.569,58.028c-1.903,15.497-0.694,46.781-0.378,54.022H448.171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M363.441,319.918c3.041-3.033,6.677-6.185,10.42-8.358 c9.569-5.556,16.359-10.495,16.359-10.495l-1.852-10.803l9.877,4.63c0,0,2.161-6.79,8.334-18.52 c6.173-11.729,6.482-14.198,6.482-14.198"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M355.419,329.07c0,0,2.532-3.411,6.35-7.436"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "398.454,316.148 384.031,451.898 389.121,451.898  401.848,320.391  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M341.692,452.007c-0.285-12.598-1.173-64.792,3.155-84.271 c4.939-22.224,9.26-47.225,16.668-57.72c7.408-10.494,22.532-23.767,30.557-31.483c8.025-7.717,12.038-17.902,12.038-17.902 l-11.112-29.94c0,0-9.877,16.668-12.964,17.902c0,0,3.087,13.89,0.926,21.915c-2.161,8.025-16.359,30.866-20.68,36.422 c-4.321,5.556-17.594,36.113-20.372,56.485c-2.45,17.97-2.739,75.32-2.773,88.592H341.692z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "380.948,253.644 396.542,253.312 391.233,241.7  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M341.692,452.007c-0.285-12.598-1.173-64.792,3.155-84.271 c4.939-22.224,9.26-47.225,16.668-57.72c7.408-10.494,22.532-23.767,30.557-31.483c2.762-2.656,5.049-5.605,6.861-8.33 c-8.811,5.996-15.816,6.195-19.964,5.419c-4.639,10.061-15.089,26.679-18.689,31.308c-4.321,5.556-17.594,36.113-20.372,56.485 c-2.45,17.97-2.739,75.32-2.773,88.592H341.692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M380.231,251.42c0,0,3.035,11.466,2.698,16.524 c-0.337,5.059-4.721,19.56-10.117,27.316c-5.396,7.756-14.164,19.56-21.246,22.595c-7.082,3.035-9.78,3.035-9.78,3.035 s13.827-5.733,16.525-22.595c2.698-16.862-6.07-57.667-6.407-60.365C351.566,235.233,380.231,251.42,380.231,251.42z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M341.442,204.71c0,0-0.667,13.348,0.667,15.684 c1.335,2.336,5.005,4.004,5.005,8.009c0,4.004-3.337,11.346-1.668,13.682c1.668,2.336,7.675,2.336,7.675,2.336 s9.01,10.345,11.346,12.68c2.336,2.336,5.673,6.007,7.341,5.339c1.669-0.667,14.349-13.682,17.352-18.687 c3.003-5.006,4.672-22.691,3.337-30.367c-1.335-7.675-20.022-20.356-30.366-21.023c-10.345-0.667-19.688,2.002-19.688,2.002 L341.442,204.71z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "353.122,219.727 355.238,225.332 363.038,220.514  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M349.352,217.534c0,0-2.118-7.944,9.533-5.826"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M357.46,245.755c0,0,5.673-1.669,10.011-8.676"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M359.055,224.032c0.324,0.605-0.128,1.48-1.011,1.953c-0.883,0.473-1.862,0.366-2.186-0.239 c-0.324-0.605,0.128-1.48,1.011-1.953C357.752,223.32,358.731,223.427,359.055,224.032z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M348.784,174.344c0,0-21.69,14.015-20.022,18.687 c1.669,4.672,12.681,11.68,12.681,11.68l1.001-7.341c0,0,11.346,5.673,22.024,9.677c10.678,4.004,10.678,4.004,10.678,4.004 s3.671,4.004,5.005,5.006c1.335,1.001,6.007,1.001,6.007,1.001s1.669,35.706,8.009,44.048c6.34,8.342,24.694,16.018,37.04,21.357 c12.347,5.339,17.787,5.759,21.124,10.43c3.337,4.672,4.631,19.515,4.631,19.515s20.176-20.838-8.402-70.323 c-20.732-35.9-18.353-40.044-25.361-52.057c-7.008-12.013-24.026-29.699-40.711-31.034 C365.802,157.659,348.784,174.344,348.784,174.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#787878",
      strokeMiterlimit: 10
    },
    d: "M428.418,259.164c2.241,1.203,4.613,2.301,7.123,3.283"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#787878",
      strokeMiterlimit: 10
    },
    d: "M376.332,172.222c0,0,16.353,12.406,19.173,34.962 c2.228,17.827,9.74,35.654,25.598,47.356"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#787878",
      strokeMiterlimit: 10
    },
    d: "M366.91,189.749c4.639,1.472,8.964,3.227,12.241,5.029"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#787878",
      strokeMiterlimit: 10
    },
    d: "M337.422,194.215c0,0-5.639-2.256,0.564-6.767 c3.677-2.674,13.496-1.782,23.233,0.681"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#787878",
      strokeMiterlimit: 10
    },
    d: "M386.158,214.054c0,0-2.669-22.358-9.01-31.034"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M271.386,362.797l-23.906-18.281 c-0.862-0.659-0.498-2.031,0.577-2.176l12.565-1.704c1.75-0.237,3.522,0.247,4.908,1.343l24.376,19.274L271.386,362.797z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M319.846,364.032c0,0-5.556-4.939-7.408-7.716 c-1.852-2.778-5.865-4.321-9.26-3.704c-3.395,0.617-11.112-1.235-12.346,0.309c-1.235,1.543-1.235,5.556-1.235,5.556 s-19.137,1.235-20.68,0.926c-1.543-0.309-2.778,2.161-1.543,4.321c1.235,2.161,10.197,4.554,10.197,4.554l0,0 c-0.007,1.739,0.386,3.45,1.151,5.011c1.317,2.686,3.514,6.84,5.32,8.646c2.778,2.778,8.643,4.013,14.816,5.247 c6.173,1.235,16.05-0.309,16.05-0.309L319.846,364.032z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 289.597,
    y1: 358.476,
    x2: 304.104,
    y2: 357.55
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M277.57,368.277c0,0,6.101-0.339,10.169,0.339 c4.068,0.678,7.457,1.356,9.83,0.678"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M278.721,373.288c0,0,5.967,1.09,8.679,2.107 s7.118,3.729,11.525,2.373"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M282.993,380.141c0,0,7.457,3.39,13.22,3.051"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M450.718,303.534c0,0,1.235,14.507,1.235,25.002 s-1.235,31.792-8.334,46.299c-7.099,14.507-5.247,24.693-12.346,39.2c-7.099,14.507-12.038,14.816-32.409,12.964 s-43.521-9.569-44.756-9.569c-1.235,0-19.446-3.395-28.088-7.717c-8.643-4.321-16.977-10.186-16.977-10.186 s0.309-3.704,1.852-7.408c1.543-3.704,6.482-30.558,6.482-30.558s9.26,5.556,17.902,8.334 c8.643,2.778,16.668,4.013,16.668,4.013s5.865-3.704,7.716-4.321c1.852-0.617,5.556,3.704,10.803,4.939 c5.247,1.235,13.272,2.469,14.507,2.469c1.235,0,13.851-1.501,12.964-1.235c-1.131,0.339-2.176-2.033-1.852-4.013 c0.18-1.098,3.087-8.025,4.013-9.26c0.926-1.235,0.926-5.865,0.926-8.951c0-3.087-4.321-35.496-2.161-44.447 c2.161-8.951,15.124-27.471,15.124-27.471s0.569-2.793,7.408-2.778c6.839,0.015,17.902,7.408,22.532,11.421"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M443.234,321.074c-2.296-2.26-5.34-4.772-8.538-6.051 c-6.636-2.654-11.944-0.664-11.944-0.664"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M447.303,325.639c0,0-0.92-1.227-2.44-2.878"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M316.89,396.159c0,0.995-0.807,1.802-1.802,1.802 c-0.995,0-1.802-0.807-1.802-1.802c0-0.995,0.807-1.802,1.802-1.802C316.083,394.358,316.89,395.164,316.89,396.159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M410.795,387.76c1.649,1.678,3.038,2.971,3.81,3.434"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M398.554,374.218c0,0,5.488,6.403,10.173,11.387"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M378.041,391.233c1.163,1.701,2.274,3.202,3.228,4.283"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M368.306,375.144c0,0,3.954,7.176,7.929,13.358"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M327.575,393.059c-1.267,5.958-2.687,11.336-4.026,13.568"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M331.575,370.205c0,0-1.247,8.73-2.976,17.767"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Line"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 92,
    y1: 452.007,
    x2: 22,
    y2: 452.007
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 472.386,
    y1: 452.007,
    x2: 102,
    y2: 452.007
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg132459145186395);
export default __webpack_public_path__ + "static/media/13245914_5186395.03a4bb045a9e95433f918a8b89bce6fe.svg";
export { ForwardRef as ReactComponent };